// frontend/src/BlogSection.js
import React, { useState, useEffect } from 'react';
import { getCookie } from './utils';
import RichTextEditor from './RichTextEditor';
import './BlogSection.css';

function BlogSection() {
  const [blogPosts, setBlogPosts] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [newPost, setNewPost] = useState({
    title: '',
    content: '',
    image: '',
  });
  const [imageFile, setImageFile] = useState(null);
  const [statusMsg, setStatusMsg] = useState('');
  const [currentUser, setCurrentUser] = useState(null);
  const [editingPostId, setEditingPostId] = useState(null);

  // Fetch blog posts
  useEffect(() => {
    fetch('/api/blog/', { credentials: 'include' })
      .then((res) => res.json())
      .then((data) => setBlogPosts(data))
      .catch((err) => console.error('Error fetching blog posts:', err));
  }, []);

  // Fetch current user info
  useEffect(() => {
    fetch('/api/user/', { credentials: 'include' })
      .then((res) => res.json())
      .then((data) => setCurrentUser(data))
      .catch((err) => console.error('Error fetching user:', err));
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewPost(prev => ({ ...prev, [name]: value }));
  };

const startEdit = (post) => {
  setNewPost({
    title: post.title,
    content: post.content,
    image: post.image,
  });
  setEditingPostId(post.id);
  setShowForm(true);
};





  const handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setImageFile(e.target.files[0]);
    }
  };

  const handleUploadImage = () => {
    if (!imageFile) return Promise.resolve('');
    const formData = new FormData();
    formData.append('image', imageFile);
    return fetch('/api/blog/upload-image/', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'X-CSRFToken': getCookie('csrftoken'),
      },
      body: formData,
    })
      .then(res => res.json())
      .then(data => {
        if (data.image_url) {
          return data.image_url;
        }
        throw new Error('Image upload failed');
      });
  };
	const handleSubmit = async (e) => {
	  e.preventDefault();
	  try {
	    const imageUrl = imageFile ? await handleUploadImage() : newPost.image;
	    const payload = { ...newPost, image: imageUrl };
	    const url = editingPostId ? `/api/blog/${editingPostId}/` : '/api/blog/';
	    const method = editingPostId ? 'PUT' : 'POST';

	    const res = await fetch(url, {
	      method,
	      credentials: 'include',
	      headers: {
		'Content-Type': 'application/json',
		'X-CSRFToken': getCookie('csrftoken'),
	      },
	      body: JSON.stringify(payload),
	    });

	    if (!res.ok) throw new Error('Failed to save blog post');
	    const updatedPost = await res.json();

	    if (editingPostId) {
	      setBlogPosts(prev =>
		prev.map(p => (p.id === editingPostId ? updatedPost : p))
	      );
	    } else {
	      setBlogPosts(prev => [updatedPost, ...prev]);
	    }

	    setNewPost({ title: '', content: '', image: '' });
	    setImageFile(null);
	    setShowForm(false);
	    setEditingPostId(null);
	    setStatusMsg('Post saved successfully.');
	  } catch (error) {
	    console.error(error);
	    setStatusMsg('Error saving blog post.');
	  }
	};


  const handleDelete = (postId) => {
    fetch(`/api/blog/${postId}/`, {
      method: 'DELETE',
      headers: {
        'X-CSRFToken': getCookie('csrftoken'),
      },
      credentials: 'include',
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Failed to delete blog post');
        }
        setBlogPosts(prevPosts => prevPosts.filter(post => post.id !== postId));
      })
      .catch((err) => {
        console.error('Error deleting blog post:', err);
        setStatusMsg('Error deleting blog post.');
      });
  };

  return (
    <div className="blog-section">
      <h2>Blog</h2>
      {statusMsg && <p className="status-msg">{statusMsg}</p>}
      <button onClick={() => setShowForm(!showForm)}>
        {showForm ? 'Cancel' : 'Create New Post'}
      </button>
      {showForm && (
        <form onSubmit={handleSubmit} className="blog-form">
          <input
            type="text"
            name="title"
            placeholder="Title"
            value={newPost.title}
            onChange={handleInputChange}
            required
          />
          <RichTextEditor
            value={newPost.content}
            onChange={(content) => setNewPost(prev => ({ ...prev, content }))}
          />
          <input type="file" onChange={handleImageChange} accept="image/*" />
          <button type="submit">Submit Post</button>
        </form>
      )}
      <div className="blog-posts">
        {blogPosts.map(post => (
          <div key={post.id} className="blog-post">
            <h3>{post.title}</h3>
            <p>
              By {post.author_username} on {new Date(post.created_at).toLocaleDateString()}
            </p>
            {post.image && <img src={post.image} alt={post.title} />}
            <div dangerouslySetInnerHTML={{ __html: post.content }} />
	   
            <p>
	  	<button onClick={() => navigator.clipboard.writeText(`${window.location.origin}/blog/${post.id}`)}>
	    	Copy Share Link
	  	</button>
		</p>


	    {currentUser && currentUser.id === post.author && (
  <>
    <button onClick={() => startEdit(post)}>Edit Post</button>
    <button onClick={() => handleDelete(post.id)}>Delete Post</button>
  </>
)}
          </div>
        ))}
      </div>
    </div>
  );
}

export default BlogSection;

